import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormioCustomComponent } from 'angular-formio';
import { FormObserverService } from '../../../services/form-observer.service';
import FormioUtils from 'formiojs/utils';
import { AlertService } from '../../../../core/alert.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';

@Component({
  selector: 'app-single-product-field',
  templateUrl: './single-product-field.component.html',
  styleUrls: ['./single-product-field.component.scss'],
})
export class SingleProductFieldComponent
  implements FormioCustomComponent<object>, OnInit
{
  disabled: boolean;
  @Input() value: object;
  @Output() valueChange = new EventEmitter<object>();
  @Input() myLabel: string;
  @Input() name: string;

  singleproduct_settings: any = [];
  hideQty: boolean = false;
  hideProductInfo: boolean = false;
  productSubtotalAmount: any;
  productPrice: any;
  productName: any;
  productQuantity: number;
  productMaximum: number;
  productPriceLabel: string;
  quantityLabel: string;
  productNameLabel: string;

  @AutoUnsubscribe()
  private castFormData$: Subscription;

  constructor(
    private formObserverService: FormObserverService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.name = this.name.replace('data[', '').replace(']', '');

    let result = [];
    this.castFormData$ = this.formObserverService.castFormData.subscribe(
      (formData: any) => {
        result = FormioUtils.searchComponents(formData, {
          type: 'singleproduct',
          key: this.name,
        });
      }
    );

    if (result && result.length > 0) {
      this.hideQty = result[0].customOptions.hideQuantity;
      this.hideProductInfo = result[0].customOptions.hideProductInfo;
      this.productPrice = result[0].customOptions.product_price;
      this.productPriceLabel = result[0].customOptions.product_price_label;
      this.productName = result[0].customOptions.product_name;
      this.productNameLabel = result[0].customOptions.product_name_label;
      this.productQuantity = result[0].customOptions.product_quantity;
      this.quantityLabel = result[0].customOptions.product_quantity_label;
      this.productMaximum = result[0].customOptions.product_maximum;
      this.productSubtotalAmount =
        result[0].customOptions.product_price *
        result[0].customOptions.product_quantity;
      setTimeout(() => {
        this.updateValue({
          label: this.productNameLabel,
          productPrice: this.productPrice,
          productName: this.productName,
          productQuantity: this.productQuantity,
          productSubtotal: this.productSubtotalAmount,
          productPriceLabel: this.productPriceLabel,
          quantityLabel: this.quantityLabel,
        });
      }, 200);
    }
  }

  updateValue(payload: object) {
    this.value = payload; // Should be updated first
    this.valueChange.emit(payload); // Should be called after this.value update
  }

  changeFn(event) {
    let new_quantity = event.target.value;
    if (event.target.value > this.productMaximum) {
      this.alertService.alertWarning({
        title: 'Warning',
        text:
          'Invalid quantity value. Maximum quantity allowed is ' +
          this.productMaximum,
      });
      event.target.value = 1;
      new_quantity = event.target.value;
    }

    if (event.target.value < 0) {
      event.target.value = 0;
      new_quantity = event.target.value;
    }

    this.productSubtotalAmount = (new_quantity * this.productPrice).toFixed(2);

    this.updateValue({
      label: this.productNameLabel,
      productPrice: +this.productPrice,
      productName: this.productName,
      productQuantity: +new_quantity,
      productSubtotal: +this.productSubtotalAmount,
      productPriceLabel: this.productPriceLabel,
      quantityLabel: this.quantityLabel,
    });
  }

  getNumColumns() {
    let col: number = 3;

    if (this.hideQty) {
      col--;
    }

    if (this.hideProductInfo) {
      col--;
    }

    return 12 / col;
  }
}
